import type { ChatRole, ParsedBlock } from '@/features/votes/chat-message';

import ImageField from './fields/ImageField';
import ModalitiesField from './fields/ModalitiesField';
import TextField from './fields/TextField';
import ToolResultField from './fields/ToolResultField';
import ToolUseField from './fields/ToolUseField';

export default function BlockRenderer({
  block,
  role,
}: {
  block: ParsedBlock;
  role: ChatRole;
}) {
  switch (block.type) {
    case 'text':
      return <TextField value={block.value} isUserMessage={role === 'user'} />;
    case 'image':
      return <ImageField value={block.value} type={block.key ?? 'image/png'} />;
    case 'tool_use':
      return <ToolUseField value={block.value} />;
    case 'tool_result':
      return <ToolResultField value={block.value} />;
    case 'modalities':
      return <ModalitiesField value={block.value} />;
    default:
      return (
        <div className="break-all rounded bg-muted/30 p-2 font-mono text-xs text-muted-foreground">
          {block.key ? `${block.key}: ` : ''}
          {block.value}
        </div>
      );
  }
}
